// Browser notices that are not app failures. Sentry drops them (app.js) and
// Cypress must not fail a test on them (cypress/support/e2e.js).
export const RESIZE_OBSERVER_LOOP_ERRORS = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications'
];
export const isBenignBrowserError = (message) => RESIZE_OBSERVER_LOOP_ERRORS.some((benignMessage) => message.includes(benignMessage));
